<template>
  <b-modal v-model="show" title="ТЕЗЛИК ВА ХАТОЛИК АНИКЛАШ" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <table class="table">
              <thead>
                <tr>
                  <th>Ҳолатлар</th>
                  <th>Олдинги</th>
                  <th>Бугунги</th>
                </tr>
              </thead>
              <tbody v-if="result">
                <tr>
                  <td>Ҳуқуқ тури</td>
                  <td>1</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td> Ер участкасига булган хукуклар</td>
                  <td>1</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td> Валюта курси</td>
                  <td>{{ result.evaluationOld.exchangeRate }}</td>
                  <td>{{ result.evaluation.exchangeRate }}</td>
                </tr>
                <tr>
                  <td> Объектнинг Жойлашган ери</td>
                  <td>{{ result.evaluationOld.regionFix }}</td>
                  <td>{{ result.evaluation.regionFix }}</td>
                </tr>
                <tr>
                  <td> Бинонинг катта-кичиклиги</td>
                  <td>{{ result.evaluationOld.areaAnalogCoefficient }}</td>
                  <td>{{ result.evaluation.areaAnalogCoefficient }}</td>
                </tr>
                <tr>
                  <td> Девори</td>
                  <td>{{ result.evaluationOld.buildingMaterialsCoefficient }}</td>
                  <td>{{ result.evaluation.buildingMaterialsCoefficient }}</td>
                </tr>
                <tr>
                  <td> Архитектуравий услуб</td>
                  <td>{{ result.evaluationOld.architecturalStyleCoefficient }}</td>
                  <td>{{ result.evaluation.architecturalStyleCoefficient }}</td>
                </tr>
                <tr>
                  <td> Бино ҳолати бўйича</td>
                  <td>{{ result.evaluationOld.stateCoefficient }}</td>
                  <td>{{ result.evaluation.stateCoefficient }}</td>
                </tr>
                <tr>
                  <td> Функцианал жихатдан фойдалилиги</td>
                  <td>{{ result.evaluationOld.categoryCoefficient }}</td>
                  <td>{{ result.evaluation.categoryCoefficient }}</td>
                </tr>
                <tr>
                  <td> Ер майдонининг катта кичиклигига тузатиш</td>
                  <td>{{ result.evaluationOld.perAreaUnitCoefficient }}</td>
                  <td>{{ result.evaluation.perAreaUnitCoefficient }}</td>
                </tr>
                <tr>
                  <td> Курилиш тугалланганлиги</td>
                  <td>{{ result.evaluationOld.constructionCompletion }}</td>
                  <td>{{ result.evaluation.constructionCompletion }}</td>
                </tr>
                <tr>
                  <td> Мухандислик камуникациялари</td>
                  <td>{{ result.evaluationOld.communicationCoefficient }}</td>
                  <td>{{ result.evaluation.communicationCoefficient }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold"> Жами купайтмаси</td>
                  <td class="font-weight-bold">{{ result.totalOldEvaluationFix | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                  <td class="font-weight-bold">{{ result.totalEvaluationFix | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold"> Кейинги нарх</td>
                  <td></td>
                  <td class="font-weight-bold">{{ result.afterEvaluationAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold"> Минимал нарх</td>
                  <td></td>
                  <td class="font-weight-bold">{{ result.minAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold"> Максимал нарх</td>
                  <td></td>
                  <td class="font-weight-bold">{{ result.maxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold"> Таққослаш объекти</td>
                  <td></td>
                  <td class="font-weight-bold">{{ result.similarRealEstateId}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold"> Қиёсий 1м2 нарх</td>
                  <td></td>
                  <td class="font-weight-bold">{{ result.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
        <button class="all-btn delete-btn float-right mr-2" @click="show=!show">
          Бекор қилиш
        </button>
      </div>
  </b-modal>
</template>
<script>
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
  export default {
    components: {
      'b-modal': bModal
    },
    directives: {
      'b-modal': bModalDirective
    },
    data() {
      return {
        show: false,
        result: null
      }
    },
    created() {
      this.$eventBus.$on('showComparativeErrorCalculateModal', (data) => {
        if (data) {
          this.result = data
        }
        this.show = true;
      });
    }
  }
</script>
<style scoped>

</style>